function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.236 1c1.049 0 1.763.852 1.893 1.893.946 7.571 1.354 22.563.946 35.018-.034 1.048-1.79 1.893-2.839 1.893s-2.803-.845-2.84-1.893c-.411-11.85 0-27.446.947-35.018.13-1.04.844-1.893 1.893-1.893z",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.397 33.179h5.679"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.59 44.062c.187 2.382-.568 7.098-8.045 9.938 3.691-3.786-.094-4.733-.473-9.938-.17-2.346 1.907-4.259 4.26-4.259s4.074 1.914 4.258 4.259z",
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}));

var SvgPaintbrush = function SvgPaintbrush(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaintbrush, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Paintbrush.2a88bc07.svg";
export { ForwardRef as ReactComponent };